import { CallEffect, PutEffect, SelectEffect, call, put, select } from 'redux-saga/effects';
import serviceLocator, { INDIVIDUAL_PORTAL_SVC } from '@APIs/common/service-locator';

import {
    fetchLanguagesFailure,
    fetchLanguagesSuccess,
    setLangauges,
    startFetchingLanguages
} from '@actions/individualPortal/preferences/communicationPreferencesActionCreators';

import { selectIfLanguagesLoaded } from '@reducers/appReducer';

export interface LanguagesSagaAction {
    skipFailureRedirect?: boolean;
}

export function* languagesSaga(action: LanguagesSagaAction = {}): Generator<
    CallEffect<unknown> | PutEffect<{ type: string }> | SelectEffect,
    void,
    any
> {
    const { skipFailureRedirect = false } = action;

    const isLanguagesLoaded: boolean = yield select(selectIfLanguagesLoaded);
    if (isLanguagesLoaded) {
        return;
    }

    yield put(startFetchingLanguages());

    try {
        const individualPortalService: ReturnType<(...args: any) => any> = yield call(
            serviceLocator,
            INDIVIDUAL_PORTAL_SVC
        );

        const languages = yield call([individualPortalService, individualPortalService.getLanguages]);
        if (languages) {
            yield put(setLangauges(languages));
        }
        yield put(fetchLanguagesSuccess());
    } catch (e) {
        yield put(fetchLanguagesFailure(skipFailureRedirect));
    }
}
